module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/5fec3130de02a77bdc4ec3c7f37d31ec.png";